<!-- modal.component.html -->
<div class="modal-overlay" *ngIf="isVisible" (click)="onOverlayClick($event)">
  <div class="modal-panel" role="dialog" [attr.aria-label]="title" (click)="$event.stopPropagation()">

    <!-- ── En-tête fixe ─────────────────────────────────────────────── -->
    <div class="modal-header">
      <div class="modal-header__left">
        <div class="modal-header__icon">
          <span class="material-icons">{{ icon }}</span>
        </div>
        <div>
          <h4 class="modal-title">{{ title }}</h4>
          <p class="modal-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
        </div>
      </div>
      <app-ui-button
        type="button"
        iconOnly="close"
        variant="ghost"
        size="sm"
        ariaLabel="Fermer"
        (clicked)="close()"
      />
    </div>

    <!-- ── Corps scrollable : tout sauf [modal-footer] ──────────────── -->
    <div class="modal-body">
      <ng-content />
    </div>

    <!-- ── Footer fixe — ne scroll jamais ───────────────────────────── -->
    <div class="modal-footer">
      <ng-content select="[modal-footer]" />
    </div>

  </div>
</div>